import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './useAuth.js';

export function Protected({ permission, anyPermission, children }) {
  const location = useLocation();
  const user = useAuth((s) => s.user);
  const ready = useAuth((s) => s.ready);
  const hasPermission = useAuth((s) => s.hasPermission);

  if (!ready) {
    return (
      <div className="flex items-center justify-center h-full p-10 text-ink-3">
        جارِ التحميل...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const okSingle = !permission || hasPermission(permission);
  const okAny =
    !anyPermission ||
    !anyPermission.length ||
    anyPermission.some((p) => hasPermission(p));

  if (!okSingle || !okAny) {
    return (
      <div className="card p-6 text-center">
        <div className="text-lg font-bold mb-2">صلاحية غير كافية</div>
        <div className="text-ink-2 text-sm">
          لا تملك صلاحية الوصول إلى هذه الصفحة
          {permission ? `: ${permission}` : ''}
        </div>
      </div>
    );
  }

  return children;
}
